import { getAreaConfigInfo } from '@/api/common/index'

/**
 * 专门来处理regionCode和域名前缀的，返回争取的本地化url
 * @returns
 */

const getDefaultState = () => {
  const param = {
    canSwitchRegion: !window.hasDefaultRegionInQuery,
    manulRegionCode: null, // 手动选择的区域码
    mobilePrefixList: [],
    // 这里默认英文，如果language是zh_CN，后面通过mapgetter通知页面更新，默认选中url中的region国家
    openRegionList: [
      {
        B: 'MY',
        C: 'Malaysia',
        domainPrefix: 'sg-',
        name: 'Singapore',
        domainSuffix: '.com',
        N: '+60'
      },
      {
        B: 'US',
        C: 'United States',
        domainPrefix: 'us-',
        name: 'America',
        domainSuffix: '.com',
        N: '+1'
      }
    ]
  }

  const url = generateLocalizeUrl(param.manulRegionCode, param.openRegionList)
  param.baseUrl = url
  return param
}

// 生成正确的本地化url，根据regionCode和openRegionList，给window.baseUrl加前缀
const generateLocalizeUrl = function (regionCode, openRegionList) {
  if (!regionCode) {
    return window.defaultBaseUrl
  }
  const region = openRegionList.find(item => item.B === regionCode)
  if (region) {
    return window.msBaseUrl
      .replace('https://', 'https://' + region.domainPrefix)
  }
  return window.defaultBaseUrl
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },

  SET_MOBILE_PREFIX_LIST: (state, mobilePrefixList) => {
    state.mobilePrefixList = mobilePrefixList
  },

  // 下面两个操作都会影响baseUrl
  SET_OPEN_REGION_LIST: (state, openRegionList) => {
    if (openRegionList?.length > 0) {
      state.openRegionList = openRegionList
      state.baseUrl = generateLocalizeUrl(state.manulRegionCode, openRegionList)
    }
  },

  SET_MANUL_REGION_CODE: (state, regionCode) => {
    // regionCode有值，并且你在openRegionList中
    if (state.openRegionList.find(item => item.B === regionCode)) {
      state.manulRegionCode = regionCode
      state.baseUrl = generateLocalizeUrl(regionCode, state.openRegionList)
    }
  }

}

const actions = {

  // 手工设置区域码
  setManulRegionCode({ commit }, regionCode) {
    commit('SET_MANUL_REGION_CODE', regionCode)
  },

  getAreaConfigInfo({ commit }) {
    return new Promise((resolve, reject) => {
      if (state.mobilePrefixList.length > 0 && state.openRegionList.length > 0) {
        resolve({})
        return
      }

      getAreaConfigInfo().then(response => {
        if (response.code === 100) {
          const result = response.mobBaseRes.result
          const areaConfigDict = result.areaConfig
          const allKeysList = Object.keys(areaConfigDict).sort()
          const resultList = allKeysList.reduce((acc, key) => {
            return acc.concat(areaConfigDict[key])
          }, [])
          commit('SET_MOBILE_PREFIX_LIST', resultList)

          const openRegionList = result.regionConfig
          commit('SET_OPEN_REGION_LIST', openRegionList)
          resolve({})
        } else {
          reject(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
